<template>  
  <vs-table
    stripe
    ref="tablaRecaudadores"
    v-on-clickaway="away"
    search
    :max-items="(maximoItems == '')?1:maximoItems"
    :data="registros"
    pagination
  >
    <template slot="header">
      <div class="form-inline">
        <h3>Registros consultados</h3>
        <input-field  
          class="input-field--stretch ml-3"
          type="tel" 
          v-mask="'###'"
          v-model="maximoItems"
          id="maximoItems"
          placeholder
        >
          <span>Cantidad de registros:</span>
        </input-field>
      </div>
    </template>
    <template slot="thead">
      <vs-th>Cerrado</vs-th>
      <vs-th>Recaudador</vs-th>
      <vs-th
        v-for="(row, indexR) in rubros"
        :key="rubros[indexR].rubro_id"
      >
        {{ rubros[indexR].rubro_descripcion + (rubros[indexR].rubro_tipo == 'I' ? ' (+)' : ' (-)') }}
      </vs-th>
    </template>
    <template slot-scope="{ data }">
      <vs-tr
        :key="indextr"
        v-for="(tr, indextr) in data"
      >
        <vs-td>
          <label :for="'seleccionado_' + data[indextr].recaudador_id">
            <input 
              type="checkbox" 
              v-model="data[indextr].cerrado" 
              :id="'seleccionado_' + data[indextr].recaudador_id" 
              :disabled="!puedeCerrar"
            >
            <span>&nbsp;</span>
          </label>
        </vs-td>
        <vs-td>{{ data[indextr].recaudador_nombre }}</vs-td>
        <vs-td
          v-for="(row, indexD) in data[indextr].detalles"
          :key="data[indextr].detalles[indexD].rubro_id"
        >
          <input-field
            v-if="editarFila"
            vMoney
            :format="decimal"
            v-model.lazy="data[indextr].detalles[indexD].valor"
            :id="'valor_' + data[indextr].detalles[indexD].rubro_id"
            :readonly="data[indextr].cerrado"
          >
          </input-field>
          <button @click="mostrarFila" class="btn-secondary btn--text" v-else>
            {{ data[indextr].detalles[indexD].valor == '' ? '-' : data[indextr].detalles[indexD].valor }}
          </button>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>  
</template>
<style scoped>
  .table-responsive {
    overflow-y: auto;
    height: 75vh;
    width: 100%;
  }
</style>
<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  props:{
    registros: {
      type: Array,
      required: false,
      default: []
    },
		rubros: {
			type: Array,
			required: false,
			default: []
		},
    puedeCerrar: {
      required: true,
    },
  },
  data() {
    return {
      editarFila: false,
      maximoItems: 15,
      decimal: decimal,
    }
  },
  methods: {
    mostrarFila: function () {
      this.editarFila = true;
    },
    away() {
      if (this.editarFila) 
        this.editarFila = false;
    },
  },
  mounted: function () { 
    document.querySelector(".vs-table--search-input").onclick = () => {
      this.away();
    };
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/TablaIngresoRubros.vue